import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { saveAs } from 'file-saver';
import { GeneraInvioModalComponent } from 'src/app/components/genera-invio-modal/genera-invio-modal.component';
import { Asl, Page } from 'src/app/model/Models';
import { RelFlussoAmbitoDto } from 'src/app/model/RelFlussoAmbito';
import { StatoInvioResponseDto } from 'src/app/model/StatoInvioResponseDto';
import { TrasmissioneFlusso } from 'src/app/model/TrasmissioneFlusso';
import { ApiService } from 'src/app/services/api.service';
import { DocumentService } from 'src/app/services/document.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  templateUrl: './invio-dati-a-regione.component.html',
  styleUrls: ['./invio-dati-a-regione.component.css']
})
export class InvioDatiARegioneComponent implements OnInit {

  paginaStorico: Page<TrasmissioneFlusso> = new Page<TrasmissioneFlusso>();
  aslList: Asl[] = [];
  ambitiList: RelFlussoAmbitoDto[] = [];

  orederBy: string = 'created_on';
  direction: string = 'DESC';

  // Dati per filtri Form
  filtriForm!: FormGroup;
  yearArray: number[] = [];
  etichette: { [key: number]: string } = {
    102: 'Primo semestre',
    702: 'Secondo semestre',
  };

  @ViewChild('dettaglioInvioModal') dettaglioInvioModal!: TemplateRef<any>;
  dettaglioInvioCorrente: StatoInvioResponseDto | null = null;
  isLoadingDettaglio: boolean = false;

  constructor(
    private apiService: ApiService,
    private documentService: DocumentService,
    private modalService: NgbModal,
    private toastService: ToastService
  ) {
    this.paginaStorico.number = 0;
    this.paginaStorico.size = 10;
  }

  ngOnInit(): void {
    this.populateYearArray();
    this.initFiltriForm();
    this.getAllAsl();
    this.caricaAmbiti();
    this.caricaStorico();
  }

  cerca() {
    this.paginaStorico.number = 0;
    this.caricaStorico();
  }

  caricaStorico() {
    const formVals = this.filtriForm.value;
    
    this.documentService.getStorico(
      this.paginaStorico.size,
      this.paginaStorico.number,
      this.orederBy,
      this.direction,
      formVals.anno,
      formVals.asl,
      formVals.siglaFlusso,
      formVals.periodo
    ).subscribe((data: any) => {
      this.paginaStorico = data;
    });
  }

  pulisciFiltri() {
    const currentYear = new Date().getFullYear();
    // emitEvent: false evita un doppio caricamento dato che stiamo per resettare
    this.filtriForm.reset({
      anno: currentYear,
      asl: '',
      siglaFlusso: '',
      periodo: ''
    }, { emitEvent: false });
    
    this.paginaStorico.number = 0;
    this.caricaStorico();
  }

  public caricaAmbiti() {
    this.apiService.getAllRelFlussoAmbito().subscribe({
      next: (data) => {
        this.ambitiList = data.filter(item => item.attiva).sort((a, b) => a.ambito.localeCompare(b.ambito));
      },
      error: (err) => {
        console.error("Errore nel caricamento degli ambiti: ", err);
      }
    });
  }

  private populateYearArray() {
    const currentYear = new Date().getFullYear();
    for (let i = currentYear; i >= 1900; i--) {
      this.yearArray.push(i);
    }
  }

  private initFiltriForm() {
    const currentYear = new Date().getFullYear();
    this.filtriForm = new FormGroup({
      anno: new FormControl(currentYear), // Impostato l'anno corrente di default
      asl: new FormControl(''),
      siglaFlusso: new FormControl(''),
      periodo: new FormControl('')
    });
  }

  public async getAllAsl() {
    this.apiService.getAllAsl().subscribe(data => {
      for (let item of data) {
        if (item.codiceAzienda != '98' && item.codiceAzienda != '098' && item.codiceAzienda != '998' && item.codiceAzienda != '999') {
          this.aslList.push(item);
        }
      }
      this.aslList.sort((a, b) => (a.denominazioneAzienda || '').localeCompare(b.denominazioneAzienda || ''));
    });
  }

  printAslName(codiceAsl: string | undefined) {
    let ret: string | undefined = '';
    this.aslList.forEach(value => {
      if (value.codiceAzienda == codiceAsl) {
        ret = value.denominazioneAzienda;
      }
    });
    return ret;
  }

  cambiaPagina(event: any) {
    this.caricaStorico();
  }

  getFilesArchiviati(flusso: any) {
    return flusso.filesArchiviati
      ?.split('||')
      .filter((fileName: string) => !!fileName && fileName.trim().length > 0)
      .sort();
  }

  downloadSingleFile(idTrasmissione: number | undefined, nomeFile: string) {
    this.documentService.downloadFileTrasmissione(idTrasmissione, nomeFile).subscribe(blob => {
      saveAs(blob, nomeFile);
    });
  }

  apriWizardInvio() {
    const modalRef = this.modalService.open(GeneraInvioModalComponent, { size: 'lg', backdrop: 'static' });
    modalRef.componentInstance.aslList = this.aslList;
    modalRef.result.then((result) => {
      if (result && result.status === 'SUCCESS') {
        this.caricaStorico();
        this.toastService.showSuccess(result.message);
      } else if (result === 'INVIO_EFFETTUATO') {
        this.caricaStorico();
      }
    }).catch(() => { });
  }

  apriDettaglioInvio(idIstanzaInvio: number | undefined) {
    if (idIstanzaInvio !== undefined) {
      this.isLoadingDettaglio = true;
      this.dettaglioInvioCorrente = null;
      this.modalService.open(this.dettaglioInvioModal, { size: 'lg', backdrop: 'static' });
      this.documentService.getStatoInvio(idIstanzaInvio).subscribe({
        next: (dettaglio) => {
          this.dettaglioInvioCorrente = dettaglio;
          this.isLoadingDettaglio = false;
        },
        error: (err) => {
          console.error('Errore recupero dettaglio invio', err);
          this.toastService.showError("Impossibile recuperare i dettagli dell'invio");
          this.isLoadingDettaglio = false;
          this.modalService.dismissAll();
        }
      });
    } else {
      this.toastService.showError('ID Istanza Invio non definito');
    }
  }

  // Funzione per ordinare alfabeticamente le etichette del periodo
  compareEtichette = (a: any, b: any) => {
    return a.value.localeCompare(b.value);
  }
}


